import { call, put, takeLatest, fork, all, delay, } from 'redux-saga/effects';
import * as Types from '../constants/Types';
import * as EmailTemplateService from './../services/emailTemplateService';
import i18n from '../constants/initLng';
import * as Func from "../helpers/functions";
import { parseListRequestParams } from '../utils/commonUtils';
import { PATHS } from '../constants/Define';
import { notification } from 'antd'
import * as emailTemplateActions from './../actions/emailTemplateAction';
import history from '../helpers/history';

function* getListEmailTemplate() {
    yield takeLatest(Types.EMAIL_TEMPLATE_LIST_ACTION, Func.sagaWrapper(function* (action) {
        const params = parseListRequestParams(action.params || {});
        const result = yield call(EmailTemplateService.getEmailTemplates, params);
        yield put(emailTemplateActions.setListEmailTemplates(result));
    }, errorHandleEmailTemplate(Types.EMAIL_TEMPLATE_FAIL)))
}

function* getAllEmailTemplate() {
    yield takeLatest(Types.EMAIL_TEMPLATE_ALL_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(EmailTemplateService.getEmailTemplates);
        yield put(emailTemplateActions.setAllEmailTemplates(result.emailTemplates));
    }, errorHandleEmailTemplate(Types.EMAIL_TEMPLATE_FAIL)))
}

function* getEmailTemplateDetail() {
    yield takeLatest(Types.EMAIL_TEMPLATE_DETAIL_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(EmailTemplateService.getEmailTemplateDetail, action.id);
        yield put(emailTemplateActions.setEmailTemplateDetail(result));
    }, errorHandleEmailTemplate(Types.EMAIL_TEMPLATE_FAIL)))
}

function* updateEmailTemplateDetail() {
    yield takeLatest(Types.EMAIL_TEMPLATE_DETAIL_UPDATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(EmailTemplateService.updateEmailTemplateDetail, action.emailTemplate);
        Func.sagaSuccessMessage({
            action,
            message: `${i18n.t('notification.updateSuccess')}`,
            description: `${i18n.t('item.emailTemplate.title')} "${action.emailTemplate.title}"`
        })
        yield put(emailTemplateActions.setEmailTemplateDetail(action.emailTemplate));
    }, errorHandleEmailTemplate(Types.EMAIL_TEMPLATE_FAIL)))
}

function* createEmailTemplateDetail() {
    yield takeLatest(Types.EMAIL_TEMPLATE_DETAIL_CREATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(EmailTemplateService.createEmailTemplateDetail, action.emailTemplate);
        Func.sagaSuccessMessage({
            action,
            message: `${i18n.t('notification.createSuccess')}`,
            description: `${i18n.t('item.emailTemplate.title')} "${action.emailTemplate.title}"`
        })
        yield put(emailTemplateActions.setEmailTemplateDetail(action.emailTemplate));
        history.push(PATHS.EMAIL_TEMPLATE.LIST.path);
        history.go();
    }, errorHandleEmailTemplate(Types.EMAIL_TEMPLATE_FAIL)))
}

function* deleteEmailTemplateDetail() {
    yield takeLatest(Types.EMAIL_TEMPLATE_DETAIL_DELETE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(EmailTemplateService.deleteEmailTemplateDetail, action.emailTemplate);
        Func.sagaSuccessMessage({ action, message: `${i18n.t('notification.removeSuccess')}` });
        yield put({ type: Types.EMAIL_TEMPLATE_LIST_ACTION, params: action.refreshParams });
    }, errorHandleEmailTemplate(Types.EMAIL_TEMPLATE_FAIL)));
}

// TRANSLATE
function* createEmailTemplateTranslate() {
    yield takeLatest(Types.EMAIL_TEMPLATE_CREATE_TRANSLATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(EmailTemplateService.createEmailTemplateTranslate, action.emailTemplate);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.201'), action.emailTemplate.translate.languageName);
        yield put({ type: Types.EMAIL_TEMPLATE_CREATE_TRANSLATE_SUCCESS });
        yield put({ type: Types.EMAIL_TEMPLATE_DETAIL_ACTION, id: action.emailTemplate.id });
    }, errorHandleEmailTemplate(Types.EMAIL_TEMPLATE_FAIL)))
}

function* updateEmailTemplateTranslate() {
    yield takeLatest(Types.EMAIL_TEMPLATE_UPDATE_TRANSLATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(EmailTemplateService.updateEmailTemplateTranslate, action.emailTemplate);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.204'), action.emailTemplate.translate.languageName);
        yield put({ type: Types.EMAIL_TEMPLATE_UPDATE_TRANSLATE_SUCCESS });
        yield put({ type: Types.EMAIL_TEMPLATE_DETAIL_ACTION, id: action.emailTemplate.id });
    }, errorHandleEmailTemplate(Types.EMAIL_TEMPLATE_FAIL)))
}

function* deleteEmailTemplateTranslate() {
    yield takeLatest(Types.EMAIL_TEMPLATE_DELETE_TRANSLATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(EmailTemplateService.deleteEmailTemplateTranslate, action.emailTemplate.translate.id);
        Func.sagaSuccessMessage(action, i18n.t('notification.removeSuccess'), action.emailTemplate.translate.languageName);
        yield put({ type: Types.EMAIL_TEMPLATE_DELETE_TRANSLATE_SUCCESS });
        yield put({ type: Types.EMAIL_TEMPLATE_DETAIL_ACTION, id: action.emailTemplate.id });
    }, errorHandleEmailTemplate(Types.EMAIL_TEMPLATE_FAIL)))
}

function errorHandleEmailTemplate(errorActionType) {
    return Func.sagaErrorHandler(function* (e) {
        yield put({ type: errorActionType })
    }, 'emailTemplate');
}

export function* emailTemplateSaga() {
    yield all([
        fork(getListEmailTemplate),
        fork(getAllEmailTemplate),
        fork(getEmailTemplateDetail),
        fork(updateEmailTemplateDetail),
        fork(createEmailTemplateDetail),
        fork(deleteEmailTemplateDetail),

        fork(createEmailTemplateTranslate),
        fork(updateEmailTemplateTranslate),
        fork(deleteEmailTemplateTranslate),
    ])
}
